import { LoadState } from "../../constants/enums";
import { ISupportTicket, ISupportState } from "./support.types";

export const initialSupportTicket: ISupportTicket = {
  support_tickets_uuid: "",
  user_uuid: "",
  title: "",
  description: "",
  category: "",
  assigned_to: "",
  resolved_at: null,
  company_outlet_uuid: "",
  status: "OPEN",
  created_by_uuid: "",
  created_by_name: "",
  modified_by_uuid: "",
  modified_by_name: "",
  create_ts: null,
  insert_ts: "",
};

export const initialSupportState: ISupportState = {
  list: {
    list: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  supportTicket: {
    data: initialSupportTicket,
    loading: LoadState.NotLoaded,
    error: null,
  },
};
